// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueAuth from '@websanova/vue-auth'
import AuthAxios from '@websanova/vue-auth/drivers/http/axios.1.x'
import AuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x'
import Buefy from 'buefy'

import AuthDriver from '@/auth-driver.js'
import App from './App'
import router from './router'
import store from './store'

Vue.use(Buefy)

Vue.use(VueRouter)
Vue.router = router
Vue.use(VueAxios, axios)

Vue.use(VueAuth, {
  refreshData: { enabled: true, interval: 10 },
  auth: AuthDriver,
  http: AuthAxios,
  router: AuthRouter
})

Vue.auth.options.tokenDefaultName = 'access_token'
// Vue.auth.options.refreshData.interval = 5

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_ROOT

Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function (el) {
    if (el.tagName === 'INPUT') {
      el.focus()
    } else {
      el.querySelector('input').focus()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
